import { defineStore } from 'pinia';

export const useManagementAuthStore = defineStore('managementAuth', {
  state: () => ({
    userId: "",
    isLogin: false,
    token: ""
  }),
  actions: {
    storeUserId(userId) {
      this.userId = userId;
    },
    storeIsLogin(isLogin) {
      this.isLogin = isLogin;
    },
    storeToken(token) {
      this.token = token;
    }
  }
});
